import { WebPlugin } from '@capacitor/core';
export class MuteWeb extends WebPlugin {
    async isMuted() {
        throw new Error('Method not implemented.');
    }
    async getPluginVersion() {
        return { version: 'web' };
    }
}
//# sourceMappingURL=web.js.map